import { useState, useEffect } from "react";
import { supabase } from "@/integrations/supabase/client";
import { Button } from "@/components/ui/button";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { toast } from "sonner";

interface Notification {
  id: string;
  vo_number: string;
  created_at: string;
  user_name: string;
}

const TestInkoop = () => {
  const [notifications, setNotifications] = useState<Notification[]>([]);
  const [selectedId, setSelectedId] = useState<string>("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    supabase
      .from("notifications")
      .select("id, vo_number, created_at, user_name")
      .order("created_at", { ascending: false })
      .limit(50)
      .then(({ data }) => setNotifications(data || []));
  }, []);

  const sendTestEmail = async () => {
    if (!selectedId) return toast.error("Selecteer een notificatie");
    setLoading(true);
    try {
      const { data, error } = await supabase.functions.invoke("send-inkoop-email", {
        body: { notification_id: selectedId },
      });
      if (error) throw error;
      toast.success(`Email verzonden! ID: ${data?.emailId || "ok"}`);
    } catch (e: any) {
      toast.error(e.message || "Fout bij verzenden");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="p-8 max-w-lg mx-auto space-y-4">
      <h1 className="text-2xl font-bold">Test Inkoop Email</h1>
      <Select value={selectedId} onValueChange={setSelectedId}>
        <SelectTrigger><SelectValue placeholder="Kies notificatie..." /></SelectTrigger>
        <SelectContent>
          {notifications.map((n) => (
            <SelectItem key={n.id} value={n.id}>
              {n.vo_number} – {n.user_name} ({new Date(n.created_at).toLocaleDateString("nl-NL")})
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
      <Button onClick={sendTestEmail} disabled={loading || !selectedId}>
        {loading ? "Verzenden..." : "Verstuur test email"}
      </Button>
    </div>
  );
};

export default TestInkoop;
